import { createEvent, type EventCallable } from 'effector'

export type PromoBannerImpressionPayload = {
  pageScreenTitle: string
  triggerType: string
  bannerType: string
  playerSessionId: string
}

export type PromoBannerClickPayload = {
  pageScreenTitle: string
  storeDestination?: string
  triggerType: string
  bannerType: string
  playerSessionId: string
}

export type PromoBannerDismissPayload = {
  pageScreenTitle: string
  triggerType: string
  bannerType: string
  playerSessionId: string
}

/**
 * Shared `banner_impression` / `banner_click` / `banner_dismiss` for install promos,
 * email capture popup, etc. Wired in `processes/analytix/banner`.
 */
export const reportPromoBannerImpression: EventCallable<PromoBannerImpressionPayload> =
  createEvent()

export const reportPromoBannerClick: EventCallable<PromoBannerClickPayload> =
  createEvent()

export const reportPromoBannerDismiss: EventCallable<PromoBannerDismissPayload> =
  createEvent()
